module.exports = __webpack_public_path__ + "img/0.5db90630.png";